'use client';

export * from 'layouts/Error';
export { default } from 'layouts/Error';
